export default function dialNumber(number) {
	window.location.assign(`tel:${number}`);
}
